<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4 ml-4">
        <v-col>
          <span class="text-h5 font-weight-bold">Create Shift</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-row>
                  <v-col md="6">
                    <v-text-field v-model="form.shift_name" label="Shift Name *" prepend-icon="mdi-clock-outline"
                      :rules="[rules.required]" :error-messages="errors.shift_name"></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field v-model="form.late_mark" label="Late Mark (minutes)" prepend-icon="mdi-clock-alert"
                      type="number" :error-messages="errors.late_mark"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6">
                    <v-text-field v-model="form.start_time" label="Start Time *" prepend-icon="mdi-clock-start"
                      type="time" :rules="[rules.required]" :error-messages="errors.start_time"></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field v-model="form.end_time" label="End Time *" prepend-icon="mdi-clock-end" type="time"
                      :rules="[rules.required]" :error-messages="errors.end_time"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6">
                    <v-text-field v-model="form.half_day_before_time" label="Half Day Before Time"
                      prepend-icon="mdi-clock-time-eight" type="time"
                      :error-messages="errors.half_day_before_time"></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-switch v-model="form.is_overnight" color="primary"
                      label="Overnight/Next Day (End time is on next day)"
                      hint="Enable for night shifts (e.g., 9PM-6AM) or 24-hour shifts (e.g., 9AM-9AM)"
                      persistent-hint></v-switch>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6">
                    <v-text-field v-model="form.break_start_time" label="Break Start Time"
                      prepend-icon="mdi-coffee" type="time"
                      hint="When the break window opens"
                      persistent-hint
                      :error-messages="errors.break_start_time"></v-text-field>
                  </v-col>
                  <v-col md="6">
                    <v-text-field v-model="form.break_end_time" label="Break End Time"
                      prepend-icon="mdi-coffee-off" type="time"
                      hint="When the break window closes"
                      persistent-hint
                      :error-messages="errors.break_end_time"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="12">
                    <v-autocomplete v-model="form.week_off_days" :items="weekDays" label="Week Off Days" multiple chips
                      prepend-icon="mdi-calendar-weekend" :error-messages="errors.week_off_days"></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6">
                    <v-autocomplete v-model="form.odd_week_off" :items="weekDays" label="Odd Week Off"
                      prepend-icon="mdi-calendar" clearable :error-messages="errors.odd_week_off"></v-autocomplete>
                  </v-col>
                  <v-col md="6">
                    <v-autocomplete v-model="form.even_week_off" :items="weekDays" label="Even Week Off"
                      prepend-icon="mdi-calendar" clearable :error-messages="errors.even_week_off"></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6">
                    <v-switch v-model="form.is_active" label="Is Active" color="primary"></v-switch>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="12">
                    <v-btn color="primary" @click="submit" :loading="isLoading" :disabled="!valid">
                      Create Shift
                    </v-btn>
                    <v-btn color="secondary" class="ml-2" to="/shift-managements">
                      Cancel
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: false,
      isLoading: false,
      weekDays: [],
      form: {
        shift_name: "",
        late_mark: "",
        start_time: "",
        end_time: "",
        is_overnight: false,
        half_day_before_time: "",
        break_start_time: "",
        break_end_time: "",
        week_off_days: [],
        odd_week_off: "",
        even_week_off: "",
        is_active: true,
      },
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get("/shift_managements/masters");
        if (response.data.weekDays && response.data.weekDays.length > 0) {
          this.weekDays = response.data.weekDays.map((day) => ({
            text: day.value,
            value: day.value,
          }));
        }
      } catch (error) {
        console.error("Error fetching masters:", error);
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          const response = await axios.post("/shift_managements", this.form);
          if (response.data.success) {
            this.$router.push("/shift-managements");
          }
        } catch (error) {
          console.error("Error creating shift:", error);
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>